<script>
export default {
  name: 'CallSuccessResult',
  data() {
    return {
      visible: false,
      options: [
        { label: '已完成', value: 0 },
        { label: '中途挂断', value: 7 },
      ],
      radioValue: '',
      otherValue: ''
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSave() {
      let val = this.options.find(item=>item.value===this.radioValue).label
      this.$emit('confirm', val)
      this.onClose()
    }
  },
  mounted() {
    this.visible = true
  }
}
</script>

<template>
  <el-dialog :visible="visible" title="呼叫结果" @close="onClose" custom-class="theme-dialog split-line-footer-dialog"
             width="520px">
    <div>
      <el-radio-group v-model="radioValue">
        <div v-for="item in options" :key="item.value" class="mb-2 last:mb-0">
          <el-radio :label="item.value">
            <span>{{ item.label }}</span>
          </el-radio>
        </div>
      </el-radio-group>
    </div>
    <template #footer>
      <div class="text-right">
        <el-button type="primary" @click="onSave">保 存</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>